import { createSelector } from 'reselect';

import { getUser } from './user.selectors';

export const selectTelephonyData = createSelector(getUser, ({ telephony }) => telephony);
